import "../css/app.css";

console.log("WeatherApp JavaScript loaded and executing.");

function keepAlive() {
  const PING_INTERVAL = 30000; // 30 seconds
  const PING_URL = '/api/v1/ping';

  setInterval(() => {
    if (document.visibilityState === 'visible') {
      const url = `${PING_URL}?_=${new Date().getTime()}`;
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.result !== 'OK') {
            console.warn('Keep-alive ping failed:', data);
          }
        })
        .catch(error => {
          console.error('Error during keep-alive ping:', error);
        });
    }
  }, PING_INTERVAL);
}

function fetchHour(hour) {
  const card = document.getElementById(`hour-${hour}`);
  if (!card) {
    console.warn(`Card for hour ${hour} not found.`);
    return Promise.resolve();
  }

  const locId = card.dataset.locationId;
  const statusEl = card.querySelector('.hourly-status');

  console.log(`Starting fetch for hour ${hour} (location ${locId})`);
  card.classList.add('loading');
  card.classList.remove('error');
  if (statusEl) statusEl.innerText = "Loading...";

  return fetch(`/api/v1/locations/${locId}/HRRR/f${hour.toString().padStart(2, '0')}`)
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.text();
    })
    .then(html => {
      console.log(`HTML received for hour ${hour}`);
      card.classList.remove('loading');
      card.classList.remove('refreshing');
      card.innerHTML = html;
    })
    .catch(err => {
      console.error(`Error fetching hour ${hour}:`, err);
      card.classList.remove('loading');
      card.classList.add('error');
      const s = card.querySelector('.hourly-status');
      if (s) s.innerText = "N/A (Click to retry)";
    });
}

function refreshDailies(locId) {
  const grid = document.getElementById('daily-grid');
  const section = document.getElementById('daily-forecast-section');
  const spinner = document.getElementById('daily-spinner');

  if (!grid) {
    console.error("daily-grid element not found!");
    return Promise.resolve();
  }

  console.log(`Refreshing dailies for location ${locId}...`);
  if (spinner) spinner.style.display = 'inline-block';

  return fetch(`/api/v1/locations/${locId}/dailies`)
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.text();
    })
    .then(html => {
      console.log(`Received daily HTML, length: ${html.length}`);
      if (html.trim().length > 0) {
        grid.innerHTML = html;
        if (section) section.style.display = 'block';
      } else {
        console.warn("Received empty HTML for dailies.");
      }
    })
    .catch(err => console.error("Failed to refresh dailies", err))
    .finally(() => {
      // Only hide if we aren't in the middle of a GFS sequence
      // (The sequence will hide it when totally done)
      const isSequenceRunning = document.getElementById('daily-grid').dataset.sequenceRunning === 'true';
      if (spinner && !isSequenceRunning) spinner.style.display = 'none';
    });
}

async function startGfsSequence(locId) {
  console.log(`Starting GFS sequence for location ${locId}...`);
  const dailySection = document.getElementById('daily-forecast-section');
  const dailySpinner = document.getElementById('daily-spinner');
  const dailyGrid = document.getElementById('daily-grid');
  
  if (dailySection) {
    dailySection.style.display = 'block';
  }
  if (dailyGrid) {
    dailyGrid.dataset.sequenceRunning = 'true';
  }
  if (dailySpinner) {
    dailySpinner.style.display = 'inline-block';
  }

  // Fetch GFS f00 through f168 in 6-hour steps
  for (let f = 0; f <= 168; f += 6) {
    const file = `f${f.toString().padStart(3, '0')}`;
    console.log(`Requesting GFS ${file}...`);
    try {
      const response = await fetch(`/api/v1/locations/${locId}/GFS/${file}`);
      if (response.ok) {
        console.log(`Successfully imported GFS ${file}`);
        await refreshDailies(locId);
      } else {
        console.warn(`Failed to import GFS ${file}: status ${response.status}`);
      }
    } catch (e) {
      console.error(`Error during GFS ${file} fetch:`, e);
    }
  }
  
  if (dailyGrid) {
    dailyGrid.dataset.sequenceRunning = 'false';
  }
  if (dailySpinner) {
    dailySpinner.style.display = 'none';
  }
  console.log("GFS sequence complete.");
}

window.retryFetch = function(hour) {
  console.log(`Manual retry for hour ${hour}`);
  const card = document.getElementById(`hour-${hour}`);
  if (card && card.classList.contains('error')) {
    fetchHour(hour);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded event fired.");
  
  const toggleBtn = document.getElementById('toggle-historical');
  const dateInput = document.getElementById('forecast-date');

  if (toggleBtn && dateInput) {
    toggleBtn.addEventListener('click', () => {
      dateInput.style.display = dateInput.style.display === 'none' ? 'inline-block' : 'none';
    });

    dateInput.addEventListener('change', () => {
      dateInput.form.submit();
    });
  }

  // Live forecast initialization
  const loadingCards = document.querySelectorAll('.hourly-card.loading[data-hour]');
  const allHourlyCards = document.querySelectorAll('.hourly-card[data-location-id]');
  const locId = allHourlyCards.length > 0 ? allHourlyCards[0].dataset.locationId : null;
  const hourlySpinner = document.getElementById('hourly-spinner');
  
  console.log(`Live forecast init: locId=${locId}, loadingCards=${loadingCards.length}, totalHourlyCards=${allHourlyCards.length}`);

  if (locId) {
    // 1. Refresh dailies if not already fresh from the server
    const dailyGrid = document.getElementById('daily-grid');
    const isFresh = dailyGrid && dailyGrid.dataset.fresh === 'true';

    if (!isFresh) {
      console.log("Dailies not fresh, triggering refresh...");
      const dailySpinner = document.getElementById('daily-spinner');
      if (dailySpinner) dailySpinner.style.display = 'inline-block';
      refreshDailies(locId);
    } else {
      console.log("Dailies are fresh, skipping initial refresh.");
    }

    if (loadingCards.length > 0) {
      console.log("Queuing HRRR hourlies...");
      const promises = Array.from(loadingCards).map((card, index) => {
        return new Promise((resolve) => {
          const hour = card.dataset.hour;
          setTimeout(() => {
            console.log(`Executing fetch for hour ${hour}`);
            fetchHour(hour).finally(() => {
              console.log(`Settled fetch for hour ${hour}`);
              resolve();
            });
          }, index * 200);
        });
      });

      // Wait for all HRRR fetches to settle before starting GFS
      Promise.all(promises).then(() => {
        console.log("ALL HRRR hourlies settled. Triggering GFS sequence...");
        if (hourlySpinner) hourlySpinner.style.display = 'none';
        startGfsSequence(locId);
      });
    } else {
      // If no HRRR cards are loading (already pre-loaded), start GFS immediately
      console.log("No HRRR hourlies loading (pre-loaded). Starting GFS sequence immediately...");
      if (hourlySpinner) hourlySpinner.style.display = 'none';
      startGfsSequence(locId);
    }
  } else {
    console.log("Not a live forecast page or no location context found.");
  }


  // Handle retries via event delegation
  const grid = document.getElementById('hourly-grid');
  if (grid) {
    console.log("Attaching retry listener to hourly-grid.");
    grid.addEventListener('click', (e) => {
      const card = e.target.closest('.hourly-card.error');
      if (card) {
        console.log(`Retry clicked for hour ${card.dataset.hour}`);
        fetchHour(card.dataset.hour);
      }
    });
  }

  keepAlive();
});
